import styles from '@components/components/HeatInstallationForm/components/InlineInfo/InlineInfo.module.scss';
import classNames from 'classnames';
import { Content, FontAwesomeProIcon } from '@wienenergiegithub/ui-next';
import React from 'react';
import PropTypes from 'prop-types';

const InlineInfo = ({ icon, className, content, size, ...props }) => (
  <div className={classNames(styles.container, className)}>
    <FontAwesomeProIcon
      className={styles.icon}
      icon={icon}
      role="presentation"
      {...props}
    />
    <Content className={styles.content} size={size}>
      {content}
    </Content>
  </div>
);

InlineInfo.propTypes = {
  className: PropTypes.string,
  content: PropTypes.node.isRequired,
  icon: PropTypes.string,
  size: PropTypes.oneOf(['xs', 'sm', 'regular', 'md', 'lg']),
};

InlineInfo.defaultProps = {
  className: null,
  icon: 'info-circle',
  size: 'regular',
};

export default InlineInfo;
